<template>
  <HeaderPart v-if="$route.path !== '/'"/>
  <router-view/>
  <FooterPart v-if="$route.path !== '/'"/>
</template>

<script>
import HeaderPart from '@/components/HeaderPart.vue'
import FooterPart from '@/components/FooterPart.vue'
import router from './router';
export default {
  
  components: {
    HeaderPart,FooterPart
  }
}
</script>

<style lang="scss"> 

.form-input{
  padding: 1px 15px;
  height: 2rem;
  
}

.form-input:focus{
  background: #f4fcff;
}

button#saveBtn:focus {
    border: 1px solid red;
    background: red;
}
table{
  font-size: small;
}
td {
    padding: 5px !important;
 text-align: left !important;
}
th {
    font-weight: bold;
    background-color: #f3f4f6;
    padding: 5px !important;
    background: #ffb628 !important;
    text-align: left !important;
}

</style>
